<template>
  <div>
      <v-navigation-drawer
        v-model="drawer"
        enable-resize-watcher
        fixed
        app
      >
        <side-drawer></side-drawer>
      </v-navigation-drawer>

      <v-toolbar
        app
        color="primary"
        class="elevation-1"
      >
        <v-toolbar-side-icon @click.stop="drawer = !drawer" class="white--text"></v-toolbar-side-icon>
        <v-spacer></v-spacer>
        <v-toolbar-title class="white--text">Supplier Help</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-content>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex>
              <v-container  fluid grid-list-xl >
                <v-layout  justify-start row wrap>
                  <v-flex>
                    <h2  class="subheading font-weight-medium">
                      The Manage Suppliers section are much simpler in comparison to the previous sections mentioned. Just as the name suggests, it's a simple way to manage and keep track of the suppliers working with your store.
                    </h2>
                  </v-flex>
                </v-layout>
              </v-container>

              <!---  ADD SUPPLIER  ---->
              <v-layout class="mb-1">
                <v-flex>
                  <v-expansion-panel>
                    <v-expansion-panel-content>
                      <template v-slot:header>
                        <div> <h1 class="title font-weight-bold">Add Supplier</h1></div>
                      </template>
                      <v-card>
                        <v-container fluid grid-list-md>
                           <v-layout>
                              <v-flex xs2 md1 class="text-xs-center">
                                <div class="round-number">
                                  1
                                </div>
                              </v-flex>
                              <v-flex xs10 md11 class="text-xs-left pt-2">
                                <h3 class="subheading font-weight-bold">
                                  In the Manage Suppliers section , simply click on the ‘+’ sign at the bottom right.
                                </h3>
                                <div class="mb-5 mt-4">
                                  <img src="/static/img/help/supplier/Click+.jpg" style="max-width:70%;" />
                                </div>
                              </v-flex>
                            </v-layout>
                            <v-layout>
                              <v-flex xs2 md1 class="text-xs-center">
                                <div class="round-number">
                                  2
                                </div>
                              </v-flex>
                              <v-flex xs10 md11 class="text-xs-left pt-2">
                                <h3 class="subheading font-weight-bold">
                                  Then fill in the Name and Phone Number.
                                </h3>
                                <div class="mb-5 mt-4">
                                  <img src="/static/img/help/supplier/FillInDetails.jpg" style="max-width:80%;" />
                                </div>
                              </v-flex>
                            </v-layout>
                            <v-layout>
                              <v-flex xs2 md1 class="text-xs-center">
                                <div class="round-number">
                                  3
                                </div>
                              </v-flex>
                              <v-flex xs10 md11 class="text-xs-left pt-2">
                                <h3 class="subheading font-weight-bold">
                                  Click Save.
                                </h3>
                              </v-flex>
                            </v-layout>
                        </v-container>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
              </v-layout>

              <!---  EDIT SUPPLIER  ---->
              <v-layout class="mb-1">
                <v-flex>
                  <v-expansion-panel>
                    <v-expansion-panel-content>
                      <template v-slot:header>
                        <div> <h1 class="title font-weight-bold">Edit Supplier</h1></div>
                      </template>
                      <v-card>
                        <v-container fluid grid-list-md>
                          <v-layout>
                            <v-flex xs2 md1 class="text-xs-center">
                              <div class="round-number">
                                1
                              </div>
                            </v-flex>
                            <v-flex xs10 md11 class="text-xs-left pt-2">
                              <h3 class="subheading font-weight-bold">
                                Navigate to the Manage Suppliers section and select the supplier you wish you edit.
                              </h3>
                            </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex xs2 md1 class="text-xs-center">
                              <div class="round-number">
                                2
                              </div>
                            </v-flex>
                            <v-flex xs10 md11 class="text-xs-left pt-2">
                              <h3 class="subheading font-weight-bold">
                                Change the Name and or Phone.
                              </h3>
                            </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex xs2 md1 class="text-xs-center">
                              <div class="round-number">
                                3
                              </div>
                            </v-flex>
                            <v-flex xs10 md11 class="text-xs-left pt-2">
                              <h3 class="subheading font-weight-bold">
                                Click SAVE
                              </h3>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
              </v-layout>

              <!---  DELETE SUPPLIER  ---->
              <v-layout class="mb-1">
                <v-flex>
                  <v-expansion-panel>
                    <v-expansion-panel-content>
                      <template v-slot:header>
                        <div> <h1 class="title font-weight-bold">Delete Supplier</h1></div>
                      </template>
                      <v-card>
                        <v-container fluid grid-list-md>
                          <v-layout>
                            <v-flex xs2 md1 class="text-xs-center">
                              <div class="round-number">
                                1
                              </div>
                            </v-flex>
                            <v-flex xs10 md11 class="text-xs-left pt-2">
                              <h3 class="subheading font-weight-bold">
                                Navigate to the Manage Suppliers section and click the supplier you wish you to delete.
                              </h3>
                            </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex xs2 md1 class="text-xs-center">
                              <div class="round-number">
                                2
                              </div>
                            </v-flex>
                            <v-flex xs10 md11 class="text-xs-left pt-2">
                              <h3 class="subheading font-weight-bold">
                                Click on the dotted icon on the top right
                              </h3>
                              <div class="mb-5 mt-4">
                                <img src="/static/img/help/supplier/ClickTripleDot.jpg" style="max-width:90%;" />
                              </div>
                            </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex xs2 md1 class="text-xs-center">
                              <div class="round-number">
                                3
                              </div>
                            </v-flex>
                            <v-flex xs10 md11 class="text-xs-left pt-2">
                              <h3 class="subheading font-weight-bold">
                                Click delete
                              </h3>
                              <div class="mb-5 mt-4">
                                <img src="/static/img/help/supplier/ClickDelete.jpg" style="max-width:90%;" />
                              </div>
                            </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex xs2 md1 class="text-xs-center">
                              <div class="round-number">
                                4
                              </div>
                            </v-flex>
                            <v-flex xs10 md11 class="text-xs-left pt-2">
                              <h3 class="subheading font-weight-bold">
                                Proceed to click DELETE when prompted for confirmation.
                              </h3>
                              <div class="mb-5 mt-4">
                                <img src="/static/img/help/supplier/ConfirmDelete.jpg" style="max-width:50%;" />
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
              </v-layout>

            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
  </div>
</template>

<script>

import SideDrawer from '@/components/SideDrawer.vue'

export default {
  data () {
    return {
      drawer: false
    }
  },
  components: {
    SideDrawer
  },
  mounted () {
    this.openDrawerForDesktop()
  }
}
</script>

<style scoped>

.round-number {
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background-color: #ff0000;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  padding-top: 3px;
}

</style>
